import styled from 'styled-components';
import layoutStyles from 'admin-components/styles/layout';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';
import { colours } from 'themes/default';

export const StyledHorizontalRule = styled(StrippedBackElement).attrs({
  element: 'hr'
})`
  border: 0;
  height: 2px;
  background: ${colours.Shades.TintBlue10};

  ${layoutStyles};
`;
